import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Sep 13 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { GlobalSettings } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { StoreName } from '../StoreName';
import { BaseStore } from '../BaseStore';
import { GlobalSettingsLayer } from '../../transportLayers/global-settings/GlobalSettingsLayer';
/**
 * This store obtaining data of product categories.
 */

export var GlobalSettingsStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(GlobalSettingsStore, _BaseStore);

  function GlobalSettingsStore(rootStore) {
    var _this;

    _classCallCheck(this, GlobalSettingsStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GlobalSettingsStore).call(this, rootStore));
    _this.name = StoreName.GlobalSettings;
    _this.globalSettingsLayer = new GlobalSettingsLayer();
    return _this;
  }
  /**
   * Will fetch all data for this page
   */


  _createClass(GlobalSettingsStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return this.globalSettingsLayer.findAll().then(function (globalSettings) {
        runInAction(function () {
          _this2.terms = globalSettings[0];
        });
        return _this2.terms;
      });
    }
  }, {
    key: "update",
    value: function update(globalSettings) {
      var _this3 = this;

      return this.globalSettingsLayer.update(globalSettings).then(function (globalSetting) {
        runInAction(function () {
          _this3.terms = globalSetting;
        });
      });
    }
  }]);

  return GlobalSettingsStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", GlobalSettings)], GlobalSettingsStore.prototype, "terms", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], GlobalSettingsStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [GlobalSettings]), __metadata("design:returntype", Promise)], GlobalSettingsStore.prototype, "update", null);